module.exports = __webpack_public_path__ + "img/nav-menu_refresh.90819910.svg";